export const SalesTypeDecorator = {
  url() {
    return `signup-hubspot/sales`;
  },
  query() {
    return {};
  }
};